import { useState } from 'react'
import { Lock } from 'react-feather'
import { useSelector } from 'react-redux'
import { Input } from 'reactstrap'
// import { resetPassword } from 'store/user/actions'
import logoLight from './images/kiwi-full-logo.svg'
import loginSideGraphic from './images/login_side_graphic.png'
import AxiosInstance from 'utils/AxiosInstance'
import { Link } from 'react-router-dom'

function ResetPassword() {
  const languageRedux = useSelector((state) => state.language?.language?.data)
  const [emailSent, setEmailSent] = useState(false)

  const language = languageRedux || {}

  const { theme } = useSelector((state) => state.themeConfig)

  const [password, setPassword] = useState('')
  const [confirmPassword, setConfirmPassword] = useState('')

  const onChangePassword = (event) => {
    setPassword(event.target.value)
  }

  const onChangeConfirmPassword = (event) => {
    setConfirmPassword(event.target.value)
  }

  const resetPassword = (event, password, confirmPassword) => {
    event.preventDefault()

    // Hardcoded default English language
    // Change to user input if needed
    const languageId = 1

    const windowUrl = new URL(window.location.href)
    const hash = windowUrl.searchParams.get('hash')

    if (!password) {
      alert('Please type your new password')
      return
    }
    if (password.length < 6) {
      alert('Password should contain at least 6 characters')
      return
    }
    if (password !== confirmPassword) {
      alert('Your password does not match')
      return
    }

    let data = {}
    data.hash = hash
    data.password = password
    data.languageId = languageId

    AxiosInstance.post(`/users/reset-password?token=${hash}`, data)
      .then((response) => {
        if (!response.success) {
          alert('Something went wrong')
          return
        }
        // if (!response.data) {
        //   alert('Something went wrong')
        //   return
        // }

        // if (!response.data.success) {
        //   alert(response.data.message)
        //   return
        // }
        setEmailSent(true)
        // dispatch(toggleSentResetEmail())
        // dispatch({ type: types.PASSWORD_CHANGED, changed: true })
      })
      .catch((error) => {
        console.error('Error resetting password:', error)
        // Handle error appropriately
      })
  }

  return (
    <>
      {' '}
      <div className='modern-login'>
        <div className='d-flex align-items-center h-100'>
          <div className='d-none d-md-block col-md-6 col-lg-7 col-xl-8 px-0'>
            <div className='hero is-fullheight is-image'>
              <div className='hero-body' style={{ height: '100vh' }}>
                <div className='h-100 d-flex align-items-center'>
                  <div className='col'>
                    <img
                      className='hero-image-blur'
                      src={
                        theme.background && theme.background.url
                          ? theme.background.url
                          : loginSideGraphic
                      }
                      alt=''
                      aria-hidden='true'
                    />
                    <img
                      className='hero-image'
                      src={
                        theme.background && theme.background.url
                          ? theme.background.url
                          : loginSideGraphic
                      }
                      alt=''
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className='col-md-6  col-lg-5 col-xl-4 px-0 is-relative'>
            <a className='top-logo mt-md-5' href='/'>
              <img
                className='light-image'
                src={
                  theme.loginLogo && theme.loginLogo.url
                    ? theme.loginLogo.url
                    : logoLight
                }
                alt=''
              />
              <img
                className='dark-image'
                src='assets/img/logos/logo/logo-light.svg'
                alt=''
              />
            </a>
            <div class='is-form mt-5 px-lg-3'>
              <div class='hero-body'>
                {!emailSent && (
                  <div class='form-text '>
                    <h2>Change Password</h2>
                  </div>
                )}

                {emailSent ? (
                  <div className='text-center'>
                    <p>Your password changed successfully...</p>
                    <Link to='/auth/new-login'>
                      <button
                        id='cancel-recover'
                        type='button'
                        className={`btn text-white login-button blue mt-3`}
                        style={{
                          backgroundColor: '#00adf2',
                        }}
                      >
                        Login
                      </button>
                    </Link>
                  </div>
                ) : (
                  <form
                    onSubmit={(e) =>
                      resetPassword(e, password, confirmPassword)
                    }
                    name='reset'
                    id='recover-form'
                    class='login-wrapper'
                  >
                    <div className='control has-validation'>
                      <Input
                        type='password'
                        name='password'
                        className='input'
                        value={password}
                        onChange={onChangePassword}
                      />
                      <div className='auth-label'>Password</div>
                      <div className='auth-icon'>
                        <Lock />
                      </div>
                    </div>
                    <div className='control has-validation'>
                      <Input
                        type='password'
                        name='confirmPassword'
                        className='input'
                        value={confirmPassword}
                        onChange={onChangeConfirmPassword}
                      />
                      <div className='auth-label'>Confirm Password</div>
                      <div className='auth-icon'>
                        <Lock />
                      </div>
                    </div>
                    <label>
                      {language.settings ? language.settings.language : null}
                    </label>

                    {/* <Select
                    options={language.languages}
                    selectedOptions={language.selectedLanguage}
                    onChange={(e) => dispatch(setUserLanguage(e.option))}
                    valueKey={'id'}
                    multi={false}
                    language={language}
                    placeholder={'test'}
                  /> */}
                    <div class='button-wrap mt-4'>
                      <button
                        type='submit'
                        className='login-button confirm'
                        // onClick={sendEmail}
                      >
                        Submit
                      </button>
                      {/* <button
                      type='button'
                      className='login-button confirm'
                      // onClick={sendEmail}
                    >
                      Log in
                    </button> */}
                    </div>
                  </form>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default ResetPassword
